import { render } from "./videoLibraryManage.vue?vue&type=template&id=5bc9a8b1&scoped=true"
import script from "./videoLibraryManage.vue?vue&type=script&lang=js"
export * from "./videoLibraryManage.vue?vue&type=script&lang=js"

import "./videoLibraryManage.vue?vue&type=style&index=0&id=5bc9a8b1&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc9a8b1"]])

export default __exports__